/**
 * 見積書エディタの右側から出るパネルの枠。
 */
import { X } from 'lucide-react';
import { forwardRef, type ReactNode } from 'react';

interface Props {
  open: boolean;
  title: string;
  onClose: () => void;
  /**
   * true のとき、パネル内のボタンを押しても入力の焦点を動かさない。
   * 品目欄に入力しながら製品リストを選ぶパネルで使う。
   */
  keepFocus?: boolean;
  children: ReactNode;
}

export const SidePanel = forwardRef<HTMLDivElement, Props>(function SidePanel(
  { open, title, onClose, keepFocus, children },
  ref,
) {
  return (
    <aside
      ref={ref}
      aria-hidden={!open}
      aria-label={title}
      className={`absolute top-0 right-0 bottom-0 z-20 w-full sm:w-[440px] flex flex-col bg-[var(--bg-surface)] border-l border-[var(--border)] shadow-[-14px_0_36px_rgba(16,24,40,0.16)] transition-[transform,visibility] duration-200 motion-reduce:transition-none ${
        open ? 'translate-x-0 visible' : 'translate-x-full invisible'
      }`}
      onMouseDown={(e) => {
        if (keepFocus && !(e.target as HTMLElement).closest('input, textarea, select')) {
          e.preventDefault();
        }
      }}
    >
      <div className="flex items-center gap-2 px-4 py-3.5 border-b border-[var(--border)]">
        <h3 className="flex-1 text-[15px] font-bold text-[var(--text-primary)]">{title}</h3>
        <button
          type="button"
          onClick={onClose}
          aria-label="パネルを閉じる"
          className="p-1.5 rounded text-[var(--text-muted)] hover:text-[var(--text-primary)] hover:bg-[var(--bg-hover)]"
        >
          <X className="size-4" />
        </button>
      </div>
      <div className="flex-1 overflow-y-auto p-4 space-y-4">{children}</div>
    </aside>
  );
});
